module.exports = __webpack_public_path__ + "img/brand-worldline.fe89adbb.svg";